import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const DataImportPage = lazy(() =>
  import('@/features/data-import/management/DataImportPage').then((m) => ({
    default: m.DataImportPage,
  })),
);

export const Route = createFileRoute('/app/data-import/')({
  component: () => (
    <Suspense>
      <DataImportPage />
    </Suspense>
  ),
});
